/**
 * Black Friday reviews (sections/bf-reviews.liquid): one review at a time. The customers' photos and the
 * previous/next buttons switch the review in place; the keyboard focus stays on the button that was pressed.
 * Without this script every review is shown, one under the other.
 */
(function () {
  function setup(root) {
    if (root._bf) return;
    root._bf = true;
    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-bf-review]"));
    var nav = root.querySelector("[data-bf-reviews-nav]");
    if (slides.length < 2 || !nav) return;
    var picks = Array.prototype.slice.call(root.querySelectorAll("[data-bf-reviews-pick]"));
    var current = root.querySelector("[data-bf-reviews-current]");
    var index = 0;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        var on = n === index;
        slide.classList.toggle("is-active", on);
        slide.setAttribute("aria-hidden", on ? "false" : "true");
        if (on) slide.removeAttribute("inert");
        else slide.setAttribute("inert", "");
      });
      picks.forEach(function (b, n) {
        if (n === index) b.setAttribute("aria-current", "true");
        else b.removeAttribute("aria-current");
      });
      if (current) current.textContent = String(index + 1);
    }

    picks.forEach(function (b) {
      b.addEventListener("click", function () { show(parseInt(b.dataset.bfReviewsPick, 10) || 0); });
    });
    root.querySelector("[data-bf-reviews-prev]").addEventListener("click", function () { show(index - 1); });
    root.querySelector("[data-bf-reviews-next]").addEventListener("click", function () { show(index + 1); });

    nav.hidden = false;
    root.dataset.ready = "true";
    show(0);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-bf-reviews]"), setup);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll("[data-bf-reviews]"), setup);
  });
  // Theme editor: selecting a review block shows it.
  document.addEventListener("shopify:block:select", function (e) {
    var slide = e.target.closest && e.target.closest("[data-bf-review]");
    var root = slide && slide.closest("[data-bf-reviews]");
    if (!root) return;
    var pick = root.querySelector('[aria-controls="' + slide.id + '"]');
    if (pick) pick.click();
  });
})();
